"use client";

import { type ReactNode } from "react";
import { useEditMode } from "@/contexts/EditModeContext";
import { cn } from "@/lib/shared/utils";
import type { CmsSectionKey } from "@/lib/validations/cms";

type EditableSectionProps = {
  sectionKey: CmsSectionKey;
  children: ReactNode;
  className?: string;
};

export default function EditableSection({ sectionKey, children, className }: EditableSectionProps) {
  const { isEditing, isSectionHidden, openSectionEditor } = useEditMode();
  const hidden = isSectionHidden(sectionKey);

  if (!isEditing) {
    if (hidden) return null;
    return <div className={className}>{children}</div>;
  }

  return (
    <div
      className={cn(
        className,
        "group/section relative",
        "outline-foreground/30 outline-2 outline-offset-4 outline-dashed",
        hidden && "opacity-30"
      )}
    >
      <div className="absolute -top-3 left-2 z-50">
        <button
          onClick={() => openSectionEditor(sectionKey)}
          className="bg-foreground text-background hover:bg-foreground/80 cursor-pointer px-2 py-0.5 font-mono text-[9px] font-bold tracking-wider uppercase transition-colors"
          title={`Edit ${sectionKey}`}
        >
          {sectionKey}
        </button>
      </div>
      {children}
    </div>
  );
}
